"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputFormatter = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _reactQuill = _interopRequireDefault(require("react-quill"));

require("react-quill/dist/quill.snow.css");

var _react = require("react");

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

var InputFormatter = function InputFormatter(_ref) {
  var _ref$mainValue = _ref.mainValue,
      mainValue = _ref$mainValue === void 0 ? "" : _ref$mainValue,
      inputId = _ref.inputId,
      articleId = _ref.articleId,
      updatedDescriptions = _ref.updatedDescriptions,
      setUpdatedDescriptions = _ref.setUpdatedDescriptions,
      isRequired = _ref.isRequired,
      maxChar = _ref.maxChar,
      disabled = _ref.disabled;

  var _useState = (0, _react.useState)(mainValue),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      selection = _useState4[0],
      setSelection = _useState4[1];

  var _useState5 = (0, _react.useState)({
    left: 0,
    top: 0
  }),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      position = _useState6[0],
      setPosition = _useState6[1];

  var _useState7 = (0, _react.useState)(0),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      charsCounter = _useState8[0],
      setCharsCounter = _useState8[1];

  var _useState9 = (0, _react.useState)({}),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      quillState = _useState10[0],
      setQuillState = _useState10[1];

  var maxLength = maxChar ? maxChar : 999;

  var getValue = function getValue(value) {
    var temp = value.replace(/\n/gm, "<br>").replace(/\&nbsp;/gm, " ").replace(/\&amp;/gm, "&");
    return temp;
  }; //const quillRef = useRef();


  var setQuill = function setQuill(ref) {
    if (!ref || ref === null) return;
    if (typeof ref.getEditor !== "function") return;
    setQuillState(ref.getEditor());
  };

  var valueFormater = function valueFormater(value) {
    return value.replace(/<\/p><p>/gm, "\n").replace(/<\/?br>|<\/?p>/gm, "").replace(/\&nbsp;/gm, " ").replace(/\&amp;/gm, "&");
  };

  var _onChange = function onChange(valueInput, h) {
    var value = "";

    try {
      if (h.getLength() - 1 <= maxLength) {
        var unformattedText = valueInput.replace(/<li.*?>/gm, "   - ").replace(/<\/li>/gm, "\n").replace(/<\/p><p>/gm, "\n").replaceAll(/<\/?(?!\/?strong).*?>/gm, "").replace(/\&nbsp;/gm, " ").replace(/\&amp;/gm, "&");
        setInputValue(valueInput);
        value = unformattedText;
      } else {
        quillState.deleteText(maxLength, quillState.getLength());
        setInputValue(function (val) {
          return val = quillState.getText();
        });
        value = quillState.getText();
      }
    } catch (error) {
      console.log(error);
    }

    setCharsCounter(h.getLength() - 1);
    value = valueFormater(value);

    if (updatedDescriptions) {
      var idInput = inputId;
      var dataSave = updatedDescriptions === null || updatedDescriptions === void 0 ? void 0 : updatedDescriptions.slice();

      if ((dataSave === null || dataSave === void 0 ? void 0 : dataSave.length) > 0) {
        var index = dataSave.findIndex(function (e) {
          return e.attributeId === idInput;
        });

        if (index !== -1) {
          if (value !== mainValue) dataSave[index].value = value;else dataSave.splice(index, 1);
        } else {
          dataSave.push({
            articleId: articleId,
            attributeId: idInput,
            value: value
          });
        }
      } else {
        if (value !== mainValue) {
          dataSave.push({
            articleId: articleId,
            attributeId: idInput,
            value: value
          });
        }
      }

      setUpdatedDescriptions(dataSave);
    }
  };

  var getSelection = function getSelection(range, a, b) {
    //getBounds(index,length)
    var selected = b.getSelection();
    var bounds = b.getBounds((selected === null || selected === void 0 ? void 0 : selected.index) || 0, (selected === null || selected === void 0 ? void 0 : selected.length) || 0);

    if (a === "user") {
      setPosition({
        left: bounds.left,
        top: bounds.top
      });
      setSelection((selected === null || selected === void 0 ? void 0 : selected.length) > 0);
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    isRequired: isRequired && (inputValue.replace(/<.*?>/gm, "").length === 0 || !inputValue),
    selection: selection,
    position: position,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactQuill.default, {
      id: inputId + "",
      ref: function ref(el) {
        return setQuill(el);
      },
      defaultValue: getValue(inputValue),
      readOnly: disabled,
      modules: {
        toolbar: ["bold"]
      },
      onKeyPress: function onKeyPress(e) {
        if (charsCounter >= maxLength && e.key !== "Backspace") {
          e.preventDefault();
        }
      },
      onKeyDown: function onKeyDown(e) {
        var keysArray = ["Backspace", "Meta", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"];

        if (charsCounter >= maxLength && keysArray.every(function (key) {
          return e.key !== key;
        })) {
          e.preventDefault();
        }
      },
      onChange: function onChange(valueInput, user, range, h) {
        return _onChange(valueInput, h);
      },
      onChangeSelection: getSelection
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: "description-limit",
      children: [charsCounter, "/", maxLength]
    })]
  });
};

exports.InputFormatter = InputFormatter;